import script from "./backButton.vue?vue&type=script&setup=true&lang=js"
export * from "./backButton.vue?vue&type=script&setup=true&lang=js"

import "./backButton.vue?vue&type=style&index=0&id=738991cd&scoped=true&lang=scss"

import exportComponent from "/home/dmytro/Projects/gcs/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-738991cd"]])

export default __exports__